import { captureException, startSpan } from "@sentry/react";

import { ITasksResponse, TaskDTO } from "../../types";
import { doGet, doPostJson } from "../core/http";

export const fetchAllTasks = async (): Promise<ITasksResponse> => {
    try {
        const response = await startSpan(
            { name: "fetchAllTasks" },
            async () => {
                return await doGet("/api/tasks", true);
            }
        );

        if (response.error) {
            captureException(response.error);
            return { error: response.error };
        }

        return {
            tasks: response.data.tasks,
            dailyTasks: response.data.dailyTasks,
        };
    } catch (e: any) {
        captureException(e);
        return { error: "Failed to fetch tasks" };
    }
};

export const fetchCompletedTasks = async (
    userId: string
): Promise<{ tasks: TaskDTO[]; error?: string }> => {
    try {
        const response = await startSpan(
            { name: "fetchCompletedTasks" },
            async () => {
                return await doGet(`/api/tasks/${userId}/completed`, false);
            }
        );

        if (response.error) {
            captureException(response.error);
            return { tasks: [], error: response.error };
        }

        return {
            tasks: response.data as TaskDTO[],
        };
    } catch (e: any) {
        captureException(e);
        return { tasks: [], error: "Failed to fetch tasks" };
    }
};

export const claimTaskReward = async (
    taskId: string
): Promise<{ success?: boolean; error?: string }> => {
    try {
        const response = await startSpan(
            { name: "claimTaskReward" },
            async () => {
                return await doPostJson(`/api/tasks/${taskId}/claim`, true, {
                    taskId,
                });
            }
        );

        if (response.error) {
            captureException(response.error);
            return { error: response.error };
        }

        return { success: true };
    } catch (e: any) {
        captureException(e);
        return { error: "Failed to claim reward" };
    }
};
